import { CheckIcon, XIcon } from 'lucide-react'
import FileAnswer from './FileAnswer'

const ApplicationAnswers = ({
  answers,
}: {
  answers: wowaudit.ApplicationAnswer[]
}) => {
  return (
    <>
      {answers && answers.length > 0 && (
        <div>
          <h3 className='text-lg font-semibold mb-3 mt-6'>Answers</h3>
          <div className='space-y-4'>
            {answers.map((answer) => (
              <div key={answer.id} className='bg-muted rounded-md p-4'>
                <div className='font-semibold text-accent-foreground mb-3 border-b border-accent pb-2'>
                  {answer.questionDescription}
                </div>
                <div className='whitespace-pre-wrap break-words'>
                  {answer.questionType === 'file' &&
                  answer.attachments.length > 0 ? (
                    <FileAnswer answer={answer} />
                  ) : answer.questionType === 'checkbox' ? (
                    <span>
                      {answer.response === 'true' ? (
                        <CheckIcon className='text-primary' />
                      ) : (
                        <XIcon className='text-destructive' />
                      )}
                    </span>
                  ) : answer.response ? (
                    answer.response
                  ) : (
                    <span className='italic text-muted-foreground'>
                      No response
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default ApplicationAnswers
